<template>
  <a href="#" @click.prevent="click">
    <span>
      <slot></slot>
    </span>
    <fa :icon="['far','arrow-right-long']" />
  </a>
</template>

<script>
export default {
  data () {
    return {

    }
  },
  methods: {
    click () {
      this.$emit("onClick")
    }
  }
}
</script>

<style lang="scss" scoped>
  a {
    display: flex;
    width: 100%;
    height: 50px;
    border-radius: $border-radius;
    background-color: $color-success;
    color: $color-secondary;
    align-items: center;
    justify-content: space-between;
    padding: 0 $hmg_mid;
    font-size: 16px;

    &:visited, &:active {
      color: $color-secondary;
    }
  }
</style>